<template>
  <v-app>
    <div class="d-flex flex-row main">
      <div id="nav">
        <NavBar />
      </div>
      <div id="content" class="d-flex flex-row ">
        <div class="nav"></div>
        <HelloWorld />
      </div>
    </div>
  </v-app>
</template>

<script>
import HelloWorld from "./views/HelloWorld";
import NavBar from "./components/navbar";
export default {
  name: "App",

  components: {
    HelloWorld,
    NavBar,
  },

  data: () => ({
    //
  }),
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");

</style>
<style scoped>
template{
  scroll-behavior: smooth;
}
.main {
  background-color: #faf8ff;
}
#nav {
  position: fixed;
  height: 100%;
}
.nav {
  width: 300px;
  /* border-right: 1px solid #e0e0e0; */
}
#content {
  width: 100%;
}
@media only screen and (max-width: 1200px) {
  .nav {
    width: 70px !important;
    height: 100%;
    background-color: #faf8ff;
    z-index: 50;
  }
  #nav{
    z-index: 2;
    height: 150vh;
  }

}
</style>
